import React from 'react';
import PropTypes from 'prop-types';

const Menu05 = ({color = 'currentColor', ...props}) => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.74967 11H14.6663M1.33301 6H14.6663M1.33301 1H14.6663"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>
);

Menu05.propTypes = {
  color: PropTypes.string,
};

export default Menu05;
